export const locales = {
    de: { label: "Deutsch", flag: "de" },
    en: { label: "English (partly implemented)", flag: "us" },
    pl: { label: "Polski (częściowo zaimplementowany)", flag: "pl" },
    "sr-Latn": { label: "Srpski (c delom implementieren)", flag: "rs" },
};
